import { CircularProgress, DialogActions, makeStyles } from '@material-ui/core';
import { Button, ModalV2, Text } from '.';

interface ChangeStatusModalProps {
  open: boolean;
  title: string | React.ReactElement;
  text: string | React.ReactElement;
  loading?: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const useStyles = makeStyles({
  actions: {
    padding: '32px 0 0',
  },
});

function ChangeStatusModal({
  open,
  title,
  text,
  loading,
  onClose,
  onSubmit,
}: ChangeStatusModalProps) {
  const classes = useStyles();

  return (
    <ModalV2 width='350px' open={open} onClose={onClose} titleProps={{ title }}>
      <Text variant='normal'>{text}</Text>
      <DialogActions className={classes.actions}>
        <Button
          variant='outlined'
          onClick={onClose}
          data-testid='button-cancel'>
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          disabled={loading}
          data-testid='button-success'>
          {loading ? <CircularProgress size={24} color='inherit' /> : 'Yes'}
        </Button>
      </DialogActions>
    </ModalV2>
  );
}

export default ChangeStatusModal;
